module.exports = __webpack_public_path__ + "media/images/emoticons/slate-801a9b89409fac73575e7802fe01151d.gif";